module.exports = __webpack_public_path__ + "media/images/lb/815-3786cdf832a918bbdfda811d7fe81fef.svg";